import { Icon, IconNames } from '@dixa/lib-shared-habla';
import cx from 'classnames';
import { ReactNode } from 'react';

import s from './toolbarButton.module.scss';

type ToolbarButtonProps = {
  icon?: IconNames;
  isActive: boolean;
  onClick?: JSX.IntrinsicElements['button']['onClick'];
  onMouseDown?: JSX.IntrinsicElements['button']['onMouseDown'];
  children?: ReactNode;
};

export const ToolbarButton = ({
  icon,
  isActive,
  onClick,
  onMouseDown,
  children,
}: ToolbarButtonProps): JSX.Element => (
  <button
    className={cx(s['toolbarButton'], isActive && s['toolbarButtonActive'])}
    onClick={onClick}
    onMouseDown={onMouseDown}
    tabIndex={-1}
  >
    {icon && <Icon className={s['toolbarButtonIcon']} name={icon} />}
    {children}
  </button>
);
